<template>
    <div class="package-management-container">
        <!-- 套餐列表区域 -->
        <el-card class="list-card" shadow="never">
            <el-row :gutter="20" align="middle" style="margin-bottom: 20px">
                <el-col :span="18">
                    <h2 style="margin: 0; font-size: 16px; color: #303133">套餐管理</h2>
                </el-col>
                <el-col :span="6" style="text-align: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAddPackageDialog">
                        新增套餐
                    </el-button>
                </el-col>
            </el-row>

            <!-- 套餐列表 -->
            <el-table :data="packageList" border style="width: 100%" :loading="listLoading"
                empty-text="暂无套餐数据，点击右上角新增套餐">
                <el-table-column label="序号" type="index" width="60" align="center" />
                <el-table-column label="套餐图片" width="200" align="center">
                    <template slot-scope="scope">
                        <img v-if="scope.row.coverImg || scope.row.image" :src="scope.row.coverImg || scope.row.image"
                            style="width: 80px; height: 80px;"
                            :preview-src-list="[scope.row.coverImg || scope.row.image]" />
                        <span v-else class="text-gray-400">暂无图片</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐名称" prop="dishName" align="center" />
                <el-table-column label="套餐原价" prop="price" align="center">
                    <template slot-scope="scope">
                        ¥{{ scope.row.price || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="折扣" prop="discount" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.discount || 0 }} 折
                    </template>
                </el-table-column>
                <el-table-column label="折扣价格" prop="discountPrice" align="center">
                    <template slot-scope="scope">
                        ¥{{ scope.row.discountPrice || 0 }}
                    </template>
                </el-table-column>
                <el-table-column label="套餐描述" prop="introduction" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.introduction || '无' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-view" size="small"
                            @click="openPackageDetail(scope.row)">
                            详情
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="deletePackage(scope.row)" size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 套餐列表分页控件 -->
            <div style="margin-top: 20px; text-align: right">
                <el-pagination @size-change="handlePackageSizeChange" @current-change="handlePackageCurrentChange"
                    :current-page="packageCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="packagePageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="packageTotalCount" :disabled="listLoading">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增套餐弹窗 -->
        <el-dialog title="新增套餐" :visible.sync="addPackageDialogVisible" width="90%" :close-on-click-modal="false"
            :before-close="handleDialogClose" :z-index="3000" append-to-body>
            <el-row :gutter="20" class="dialog-content">
                <!-- 左侧：套餐基础信息 -->
                <el-col :span="12">
                    <el-card title="套餐基础信息" class="base-info-card" shadow="never">
                        <el-form ref="packageForm" :model="packageForm" :rules="packageRules" label-width="100px">
                            <el-form-item label="套餐名称" prop="dishName">
                                <el-input v-model="packageForm.dishName" placeholder="请输入套餐名称（如：周一午餐套餐A）" maxlength="50"
                                    show-word-limit />
                            </el-form-item>

                            <el-form-item label="套餐原价" prop="price">
                                <el-input v-model="packageForm.price" placeholder="选中菜品后自动计算总价" prefix="¥"
                                    @change="calculateDiscountPrice" />
                            </el-form-item>

                            <el-form-item label="折扣" prop="discount">
                                <el-input v-model="packageForm.discount" placeholder="请输入折扣（如8表示8折）"
                                    @input="calculateDiscountPrice" @change="calculateDiscountPrice"
                                    oninput="value=value.replace(/[^0-9.]/g,'')">
                                    <template slot="suffix">折</template>
                                </el-input>
                            </el-form-item>

                            <el-form-item label="折扣价格" prop="discountPrice">
                                <el-input v-model="packageForm.discountPrice" placeholder="打折后菜品总价" prefix="¥"
                                    disabled />
                            </el-form-item>

                            <el-form-item label="套餐描述">
                                <el-input v-model="packageForm.introduction" type="textarea"
                                    placeholder="请输入套餐描述（如：包含主食+菜品+汤品）" :rows="3" maxlength="200" show-word-limit />
                            </el-form-item>

                            <!-- 套餐图片上传 -->
                            <el-form-item label="套餐图片" prop="coverImg">
                                <div v-if="packageForm.coverImg" class="package-img-preview mb-2">
                                    <el-image :src="packageForm.coverImg" fit="cover"
                                        style="width: 120px; height: 90px; border-radius: 4px;"
                                        :preview-src-list="[packageForm.coverImg]" />
                                </div>
                                <el-upload class="upload-demo" :action="''" :http-request="customUpload"
                                    :on-remove="handleImgRemove" :file-list="packageImgFileList"
                                    :disabled="uploadLoading" accept="image/*" :limit="1" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                    <div class="el-upload__text">点击上传套餐图片</div>
                                </el-upload>
                                <div class="el-upload__tip text-gray-500 mt-1">
                                    支持jpg/png格式，大小不超过200KB
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <!-- 已选菜品预览 -->
                    <el-card title="已选菜品" class="selected-dishes-card" style="margin-top: 20px" shadow="never">
                        <div class="selected-count">
                            共选中 <span class="count-num">{{ selectedDishList.length }}</span> 个菜品
                            <span style="margin-left: 20px; color: #f56c6c; font-weight: 500;">
                                菜品原价：¥{{ calculateSelectedDishTotal() || 0 }}
                            </span>
                        </div>

                        <el-empty v-if="!selectedDishList.length" description="暂无选中菜品" :image-size="80" />

                        <div class="selected-dish-list-optimized" v-else style="display: flex;flex-wrap: wrap;">
                            <div v-for="(dish, index) in selectedDishList" :key="dish.mealId || index"
                                class="optimized-dish-item" style="width: 20%;">
                                <el-image :src="dish.coverImg || dish.imgUrl || defaultDishImg" fit="cover"
                                    style="width: 60px; height: 60px; border-radius: 4px;"
                                    :preview-src-list="[dish.coverImg]" />
                                <div class="optimized-dish-info">
                                    <div class="optimized-dish-name">{{ dish.dishName || dish.name }}</div>
                                    <div class="optimized-dish-price">¥{{ dish.price || 0 }} × {{ dish.num || 1 }}份
                                    </div>
                                    <div class="optimized-dish-total">小计：¥{{ (dish.price || 0) * (dish.num || 1) }}
                                    </div>
                                    <el-button type="text" icon="el-icon-delete" class="optimized-remove-btn"
                                        @click="removeSelectedDish(dish)">
                                        移除
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>

                <!-- 右侧：菜品选择区域 -->
                <el-col :span="12">
                    <el-card title="菜品选择" class="dish-select-card" shadow="never">
                        <el-tabs v-model="activeTab" @tab-change="handleTabChange">
                            <el-tab-pane label="成品菜" name="finished"></el-tab-pane>
                        </el-tabs>

                        <el-table :data="paginatedDishList" border style="width: 100%; margin-top: 20px"
                            :loading="loadingDish">
                            <el-table-column label="菜品图片" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-image :src="scope.row.coverImg" fit="cover"
                                        style="width: 80px; height: 80px; border-radius: 4px"
                                        :preview-src-list="[scope.row.coverImg]" />
                                </template>
                            </el-table-column>

                            <el-table-column label="菜品名称" prop="dishName" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.dishName || scope.row.name }}
                                </template>
                            </el-table-column>

                            <el-table-column label="价格" prop="price" width="100" align="center">
                                <template slot-scope="scope">
                                    ¥{{ scope.row.price || 0 }}
                                </template>
                            </el-table-column>

                            <el-table-column label="份数" width="220" align="center">
                                <template slot-scope="scope">
                                    <el-input-number v-model.number="scope.row.num" :min="0" :max="99"
                                        @change="handleNumChange(scope.row)" @input="$forceUpdate" @click.stop
                                        size="small" controls-position="right" />
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="allDishList.length"
                            style="margin-top: 20px; text-align: right" :disabled="loadingDish">
                        </el-pagination>
                    </el-card>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button type="primary" icon="el-icon-check" @click="savePackage"
                    :disabled="!packageForm.dishName || !packageForm.price || packageForm.price < 0.01 || !selectedDishList.length || !packageForm.coverImg || !packageForm.discount || packageForm.discount < 0.01">
                    保存套餐
                </el-button>
            </div>
        </el-dialog>

        <!-- 套餐详情抽屉弹窗 -->
        <el-drawer title="套餐详情" :visible.sync="detailDrawerVisible" direction="rtl" size="60%" :z-index="3001"
            append-to-body>
            <div class="package-detail-container" v-if="currentPackage">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-card title="基础信息" shadow="never" class="detail-card">
                            <el-descriptions :column="1" border style="width: 100%">
                                <el-descriptions-item label="套餐图片">
                                    <el-image v-if="currentPackage.coverImg || currentPackage.image"
                                        :src="currentPackage.coverImg || currentPackage.image" fit="cover"
                                        style="width: 120px; height: 90px; border-radius: 4px;"
                                        :preview-src-list="[currentPackage.coverImg || currentPackage.image]" />
                                    <span v-else class="text-gray-400">暂无图片</span>
                                </el-descriptions-item>
                                <el-descriptions-item label="套餐名称">
                                    {{ currentPackage.dishName }}
                                </el-descriptions-item>
                                <el-descriptions-item label="套餐原价">
                                    ¥{{ currentPackage.price || 0 }}
                                </el-descriptions-item>
                                <el-descriptions-item label="折扣">
                                    {{ currentPackage.discount || 0 }} 折
                                </el-descriptions-item>
                                <el-descriptions-item label="折扣价格">
                                    ¥{{ currentPackage.discountPrice || 0 }}
                                </el-descriptions-item>
                                <el-descriptions-item label="套餐描述">
                                    {{ currentPackage.introduction || '无' }}
                                </el-descriptions-item>
                                <el-descriptions-item label="菜品总数">
                                    {{ selectedDishes?.length || 0 }} 个
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-card>
                    </el-col>

                    <el-col :span="12">
                        <el-card title="包含菜品" shadow="never" class="detail-card">
                            <div class="dish-count"
                                style="margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #f0f2f5;">
                                共 {{ selectedDishes?.length }} 个菜品
                            </div>

                            <el-empty v-if="!selectedDishes?.length && !currentPackage.comboItems?.length"
                                description="该套餐暂无菜品" :image-size="80" />

                            <div class="selected-dish-list-optimized" v-else style="display: flex;flex-wrap: wrap;">
                                <div v-for="(dish, index) in selectedDishes" :key="dish.mealId || index"
                                    class="optimized-dish-item" style="width: 25%;">
                                    <el-image :src="dish.image || dish.coverImg" fit="cover"
                                        style="width: 60px; height: 60px; border-radius: 4px;" />
                                    <div class="optimized-dish-info">
                                        <div class="optimized-dish-name">{{ dish.dishName || dish.name }}</div>
                                        <div class="optimized-dish-price">¥{{ dish.price || 0 }} × {{ dish.num || 1 }}份
                                        </div>
                                        <div class="optimized-dish-total">小计：¥{{ (dish.price || 0) * (dish.num || 1) }}
                                        </div>
                                        <div class="optimized-dish-spec">
                                            {{ dish.mealPeriod ? `餐别：${dish.mealPeriod}` : '' }}
                                            {{ dish.parsedIngredients ? ` | 主料：${dish.parsedIngredients}` : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>

            <div slot="footer" class="drawer-footer" style="text-align: right">
                <el-button @click="detailDrawerVisible = false">关闭</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { Message, MessageBox } from "element-ui";
import { getDishList, del } from "@/api/dish";
import { addCombo, getComboItem } from "@/api/combo";

export default {
    data() {
        return {
            // 套餐列表相关
            packageList: [],
            listLoading: false,
            packageCurrentPage: 1,
            packagePageSize: 10,
            packageTotalCount: 0,
            // 弹窗/抽屉控制
            addPackageDialogVisible: false,
            detailDrawerVisible: false,
            currentPackage: null,
            // 图片相关
            defaultDishImg: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            packageImgFileList: [],
            uploadLoading: false,
            // 菜品相关
            loadingDish: false,
            currentPage: 1,
            pageSize: 10,
            activeTab: "finished",
            allDishList: [],
            paginatedDishList: [],
            selectedDishList: [],
            selectedDishes: [],
            // 表单数据
            packageForm: {
                dishName: "",
                price: "", // 套餐原价
                discount: "", // 折扣（如0.8）
                discountPrice: "", // 折扣价格（自动计算）
                introduction: "",
                coverImg: ""
            },
            // 表单校验规则
            packageRules: {
                dishName: [
                    { required: true, message: "请输入套餐名称", trigger: "blur" },
                    { min: 2, max: 50, message: "套餐名称长度在 2 到 50 个字符", trigger: "blur" }
                ],
                price: [
                    { required: true, message: "请选择菜品自动计算或手动输入套餐价格", trigger: "blur" },

                    { min: 0.01, message: "套餐价格不能小于0.01元", trigger: "blur" }
                ],
                discount: [
                    { required: true, message: "请输入折扣", trigger: "blur" },

                    { min: 0.01, max: 10, message: "折扣范围在0.01-10之间（0.8表示8折）", trigger: "blur" }
                ],
                coverImg: [
                    { required: true, message: "请上传套餐图片", trigger: "change" }
                ]
            }
        };
    },
    created() {
        this.getDishData();
        this.getPackageList();
    },
    methods: {
        // 获取套餐内菜品
        getList() {
            console.log(this.currentPackage);
            getComboItem({ pid: this.currentPackage.id }).then(response => {
                console.log(response);
                this.selectedDishes = response.data
            })
        },
        // 获取套餐列表
        async getPackageList() {
            try {
                this.listLoading = true;
                const response = await getDishList({
                    userId: localStorage.getItem("userId"),
                    type: "套餐"
                });
                this.packageList = response.data || [];
                this.packageTotalCount = response.data.length || 0;
            } catch (error) {
                console.error("获取套餐列表失败:", error);
                Message.error("获取套餐列表失败，请刷新页面");
                this.packageList = [];
                this.packageTotalCount = 0;
            } finally {
                this.listLoading = false;
            }
        },
        // 套餐列表分页-页大小改变
        handlePackageSizeChange(val) {
            this.packagePageSize = val;
            this.packageCurrentPage = 1;
            this.getPackageList();
        },
        // 套餐列表分页-当前页改变
        handlePackageCurrentChange(val) {
            this.packageCurrentPage = val;
            this.getPackageList();
        },
        // 获取菜品列表数据
        async getDishData() {
            try {
                this.loadingDish = true;
                const response = await getDishList({
                    userId: localStorage.getItem("userId"),
                    type: "成品菜"
                });
                const rawData = response.data || [];
                this.allDishList = rawData.map((item) => {
                    const dish = { ...item };
                    this.$set(dish, 'num', 0);
                    return dish;
                });
                this.updatePaginatedDishList();
            } catch (error) {
                console.error("获取菜品列表失败:", error);
                Message.error("获取菜品列表失败，请刷新页面");
                this.allDishList = [].map(item => {
                    this.$set(item, 'num', 0);
                    return item;
                });
                this.updatePaginatedDishList();
            } finally {
                this.loadingDish = false;
            }
        },
        // 更新分页后的菜品列表
        updatePaginatedDishList() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.paginatedDishList = this.allDishList.slice(startIndex, endIndex);
        },
        // 打开新增套餐弹窗
        openAddPackageDialog() {
            this.resetForm();
            this.addPackageDialogVisible = true;
        },
        // 打开套餐详情抽屉
        openPackageDetail(row) {
            this.currentPackage = { ...row };
            this.detailDrawerVisible = true;
            this.getList()
        },
        // 关闭新增弹窗
        handleDialogClose() {
            this.addPackageDialogVisible = false;
            setTimeout(() => {
                this.resetForm();
            }, 300);
        },
        // 份数变化：自动更新选中列表
        handleNumChange(row) {
            let newNum = Number(row.num) || 0;
            if (newNum < 0) newNum = 0;
            if (newNum > 99) newNum = 99;
            row.num = newNum;
            this.updateSelectedList(); // 触发价格自动计算
        },
        /**
         * 计算折扣价格（折扣 × 原价）
         * 自动保留两位小数，处理空值/非数字情况
         */
        calculateDiscountPrice() {
            // 转换为数字，空值/非数字转为0
            const originalPrice = Number(this.packageForm.price) || 0;
            const discount = Number(this.packageForm.discount) || 0;

            // 只有原价和折扣都有效时才计算
            if (originalPrice > 0 && discount > 0) {
                // 保留两位小数，避免浮点精度问题
                this.packageForm.discountPrice = (Math.round(originalPrice * discount) / 10).toFixed(2);
            } else {
                this.packageForm.discountPrice = ""; // 无效时清空
            }
        },
        /**
         * 更新已选列表 + 实时计算套餐价格 + 触发折扣价格计算
         */
        updateSelectedList() {
            // 筛选已选菜品（份数>0）
            this.selectedDishList = this.allDishList
                .filter(item => item.num > 0)
                .map(item => ({ ...item }));
            // 自动计算菜品总价并填充到套餐价格输入框
            const totalPrice = this.calculateSelectedDishTotal();
            this.packageForm.price = totalPrice;

            // 原价变化后自动计算折扣价格
            this.calculateDiscountPrice();
        },
        /**
         * 计算已选菜品的总价，返回保留两位小数的字符串
         * 公式：Σ(菜品单价 × 菜品份数)，保留两位小数（金额规范）
         */
        calculateSelectedDishTotal() {
            if (!this.selectedDishList.length) return ""; // 无菜品时返回空，避免显示0
            const total = this.selectedDishList.reduce((sum, dish) => {
                const price = Number(dish.price) || 0;
                const num = Number(dish.num) || 1;
                return sum + (price * num);
            }, 0);
            return total.toFixed(2); // 保留两位小数，适配金额展示
        },
        // 移除已选菜品：将份数重置为0
        removeSelectedDish(dish) {
            const target = this.allDishList.find(item => item.mealId === dish.mealId);
            if (target) {
                target.num = 0;
                this.updateSelectedList(); // 触发价格自动计算
                this.updatePaginatedDishList();
            }
        },
        // 重置表单：份数重置为0，价格清空
        resetForm() {
            if (this.$refs.packageForm) {
                this.$refs.packageForm.resetFields();
            }
            this.packageImgFileList = [];
            this.packageForm.coverImg = "";
            this.allDishList.forEach(item => {
                item.num = 0;
            });
            this.selectedDishList = [];
            this.packageForm.price = "";
            // 重置折扣相关字段
            this.packageForm.discount = "";
            this.packageForm.discountPrice = "";
            this.currentPage = 1;
            this.updatePaginatedDishList();
        },
        // 图片转Base64
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = (error) => reject(error);
            });
        },
        // 图片上传前校验
        beforePackageImgUpload(file) {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                this.$message.error('请上传图片格式文件！');
                return false;
            }
            const isLt200K = file.size / 1024 < 200;
            if (!isLt200K) {
                this.$message.error('套餐图片大小不能超过200KB！');
                return false;
            }
            return true;
        },
        // 自定义图片上传方法
        async customUpload(options) {
            const file = options.file;
            if (!this.beforePackageImgUpload(file)) {
                options.onError(new Error("文件校验失败"));
                return;
            }
            this.uploadLoading = true;
            try {
                const base64Url = await this.getBase64(file);
                this.packageForm.coverImg = base64Url;
                this.packageImgFileList = [{
                    name: file.name,
                    url: base64Url
                }];
                Message.success("套餐图片上传成功");
                options.onSuccess({ code: 200, data: { url: base64Url } });
            } catch (error) {
                console.error("图片上传失败:", error);
                Message.error(error.message || "套餐图片上传失败，请重试");
                options.onError(error);
            } finally {
                this.uploadLoading = false;
            }
        },
        // 移除图片时清空地址
        handleImgRemove(file, fileList) {
            this.packageForm.coverImg = "";
            this.packageImgFileList = fileList;
        },
        /**
         * 保存套餐：新增折扣价格字段提交
         */
        async savePackage() {
            this.$refs.packageForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 转换为数字类型
                        const packagePrice = Number(this.packageForm.price);
                        const discount = Number(this.packageForm.discount);
                        const discountPrice = Number(this.packageForm.discountPrice);

                        // 二次校验
                        if (packagePrice < 0.01) {
                            Message.error("套餐价格不能小于0.01元，请重新选择菜品或手动修改");
                            return;
                        }
                        if (discount < 0.01 || discount > 10) {
                            Message.error("折扣范围在0.01-10之间（0.8表示8折）");
                            return;
                        }

                        // 构造套餐数据（新增折扣相关字段）
                        const newPackage = {
                            dishType: '套餐',
                            dishName: this.packageForm.dishName,
                            price: packagePrice, // 原价
                            discount: discount, // 折扣
                            discountPrice: discountPrice, // 折扣价格
                            introduction: this.packageForm.introduction,
                            image: this.packageForm.coverImg,
                            comboItems: this.selectedDishList.map((dish) => ({
                                mealId: dish.mealId,
                                dishName: dish.dishName || dish.name,
                                price: dish.price,
                                image: dish.coverImg,
                                num: dish.num || 1,
                                mealPeriod: dish.mealPeriod,
                                parsedIngredients: dish.parsedIngredients
                            })),
                            userId: localStorage.getItem("userId")
                        };

                        // 调用接口保存
                        const response = await addCombo(newPackage);
                        if (response.code === 200) {
                            Message.success("套餐保存成功！");
                            this.addPackageDialogVisible = false;
                            this.resetForm();
                            this.getPackageList();
                        } else {
                            Message.error(response.message || "套餐保存失败");
                        }
                    } catch (error) {
                        console.error("调用addCombo接口失败:", error);
                        Message.error("网络错误，套餐保存失败");
                    }
                } else {
                    Message.error("请完善套餐信息后再保存！");
                    return false;
                }
            });
        },
        // 删除套餐
        async deletePackage(row) {
            try {
                await MessageBox.confirm(
                    "此操作将永久删除该套餐，是否继续？",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                );
                const response = await del({
                    id: row.id,
                    userId: localStorage.getItem("userId")
                });
                if (response.code === 200) {
                    this.getPackageList()
                    Message.success("套餐删除成功！");
                } else {
                    Message.error(response.message || "套餐删除失败");
                }
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除套餐失败:", error);
                    Message.error("删除套餐失败，请重试");
                }
            }
        },
        // 标签页切换
        handleTabChange() {
            this.currentPage = 1;
            this.updatePaginatedDishList();
        },
        // 菜品列表分页-每页条数变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.updatePaginatedDishList();
        },
        // 菜品列表分页-当前页变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.updatePaginatedDishList();
        },
        // 计算套餐内菜品的总份数（备用）
        calculatePackageDishTotalNum(dishes) {
            if (!dishes || !dishes.length) return 0;
            return dishes.reduce((total, dish) => {
                return total + (Number(dish.num) || 1);
            }, 0);
        }
    }
};
</script>

<style lang="scss" scoped>
.package-management-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;

    .list-card {
        background-color: #fff;
        padding: 20px;
    }

    .dialog-content {
        .base-info-card {
            height: fit-content;
        }

        .selected-dishes-card {
            .selected-count {
                font-size: 14px;
                color: #1f2d3d;
                margin-bottom: 15px;
                padding-bottom: 10px;
                border-bottom: 1px solid #f0f2f5;

                .count-num {
                    color: #409eff;
                    font-weight: bold;
                }
            }

            .selected-dish-list-optimized {
                display: flex;
                flex-wrap: wrap;

                .optimized-dish-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                    padding: 8px 0;
                    border-bottom: 1px dashed #f0f2f5;
                    width: 20%;

                    &:last-child {
                        border-bottom: none;
                        margin-bottom: 0;
                    }

                    &>.el-image {
                        margin-right: 12px;
                    }

                    .optimized-dish-info {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;

                        .optimized-dish-name {
                            font-size: 14px;
                            color: #303133;
                            margin-bottom: 4px;
                            font-weight: 500;
                        }

                        .optimized-dish-price {
                            font-size: 13px;
                            color: #f56c6c;
                            margin-bottom: 2px;
                        }

                        .optimized-dish-total {
                            font-size: 12px;
                            color: #606266;
                            margin-bottom: 6px;
                        }

                        .optimized-remove-btn {
                            color: #409eff;
                            padding: 0;
                            font-size: 12px;

                            &:hover {
                                color: #66b1ff;
                            }
                        }
                    }
                }
            }
        }

        .dish-select-card {
            height: fit-content;
            max-height: 600px;
            overflow-y: auto;

            .el-table {
                --el-table-row-hover-bg-color: #f8f9fa;
            }

            ::v-deep .el-input-number {
                width: 100px;

                .el-input-number__decrease,
                .el-input-number__increase {
                    height: 20px;
                    line-height: 20px;
                }
            }
        }
    }

    .dialog-footer {
        text-align: right;
    }

    .package-detail-container {
        .detail-card {
            margin-bottom: 20px;

            .el-descriptions {
                --el-descriptions-label-color: #606266;
                --el-descriptions-content-color: #303133;
            }
        }
    }

    .package-img-preview {
        margin-bottom: 8px;
    }

    ::v-deep .el-upload--picture-card {
        width: 120px;
        height: 90px;
        line-height: 90px;
    }

    .mb-2 {
        margin-bottom: 8px;
    }

    .mt-1 {
        margin-top: 4px;
    }

    .text-gray-400 {
        color: #c0c4cc;
    }

    .text-gray-500 {
        color: #909399;
        font-size: 12px;
    }
}
</style>